// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nCTm","colBig":"styles_colBig__29_sE","colSmall":"styles_colSmall__TdUEv"};